<!-- eslint-disable vue/multi-word-component-names -->
<template>
<hr />
<p style="color: darkgray; text-align: center;">© IC Safety Solutions 2025</p>
    

</template>
<script>
export default {}
</script>

<style>
hr {
    margin: 0% 13%;
}
</style>